import { ReactElement } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

import { MakePropertiesOptional } from '@utils/types';

export type LinkProps = MakePropertiesOptional<RouterLinkProps, 'to'>;

export const Link = ({ children, to, ...rest }: LinkProps): ReactElement => {
  if (!to) {
    return <>{children}</>;
  }
  return <RouterLink to={to} children={children} {...rest} />;
};
